<template>
  <div
    v-show="visualizationLayerType != 'default'"
    class="visualization-color-chart"
  >
    <v-ons-row vertical-align="center">
      <v-ons-col width="68px">
        <img
          :src="icon"
          width="60px"
        >
      </v-ons-col>
      <!-- NOTE: 体感温度 -->
      <visualization-setstar-color-chart v-if="visualizationLayerType === 'setstar'" />
      <!-- NOTE: にぎわい度 -->
      <visualization-sound-color-chart v-if="visualizationLayerType === 'sound'" />
      <!-- NOTE: 混雑度 -->
      <visualization-congestion-color-chart v-if="visualizationLayerType === 'congestion'" />
      <!-- NOTE: 混雑度 -->
      <visualization-temperature-color-chart v-if="visualizationLayerType === 'temperature'" />
      <!-- NOTE: 明るさ -->
      <visualization-brightness-color-chart v-if="visualizationLayerType === 'brightness'" />

    </v-ons-row>

  </div>
</template>

<script>
import visualizationSetstarColorChart from './setstar.vue';
import visualizationSoundColorChart from './sound.vue';
import visualizationCongestionColorChart from './congestion.vue';
import visualizationTemperatureColorChart from './temperature.vue';
import visualizationBrightnessColorChart from './brightness.vue';
import config from '@/config.js';

export default {
  components: {
    visualizationSetstarColorChart,
    visualizationSoundColorChart,
    visualizationCongestionColorChart,
    visualizationTemperatureColorChart,
    visualizationBrightnessColorChart,
  },
  computed: {
    visualizationLayers: () => config.visualizationLayers,
    visualizationLayerType: ({ $store }) => $store.state.map.visualizationLayerType,
    icon: (vm) => vm.visualizationLayers.find((layer) => layer.value === vm.visualizationLayerType).image,
  },
};
</script>

<style scoped lang="scss">
.visualization-color-chart {
  position: absolute;
  top: 0;
  right: 160px;
  z-index: 100;
  box-sizing: border-box;
  padding: 3px;
  height: 70px;
  width: 367px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  line-height: 1;

  /deep/ {
    .color-chart {
      margin-top: 9px;
      margin-bottom: 4px;
      padding-left: 0.5em;
      padding-right: 0.5em;
      height: 14px;
      &-text {
        justify-content: space-between;
        ons-col {
          flex: 0;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// frame.vue?ebff8fda